import React from 'react'
import { EmblaOptionsType } from 'embla-carousel'
import {
    PrevButton,
    NextButton,
    usePrevNextButtons
} from './ArrowButtons'
import {
    SelectedSnapDisplay,
    useSelectedSnapDisplay
} from './SnapDisplay'
import useEmblaCarousel from 'embla-carousel-react'
import Product from './Product'
import '../../../css/embla-carousel.css';

type PropType = {
    slides: number[]
    options?: EmblaOptionsType
}

const Carousel: React.FC<PropType> = (props) => {
    const { slides, options } = props
    const [emblaRef, emblaApi] = useEmblaCarousel(options)

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick
    } = usePrevNextButtons(emblaApi)

    const { selectedSnap, snapCount } = useSelectedSnapDisplay(emblaApi)

    return (
        <section className="embla-carousel">
            <div className="embla__viewport-carousel" ref={emblaRef}>
                <div className="embla__container-carousel">
                    {slides.map((product, index) => (
                        <div className="embla__slide-carousel basis-[75%] sm:basis-[45%] md:basis-[45%] lg:basis-1/5" key={index}>
                            <Product product={product} />
                        </div>
                    ))}
                </div>
            </div>

            {/* <div className="embla__controls-carousel">
                <div className="embla__buttons-carousel">
                    <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
                    <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
                </div>

                <SelectedSnapDisplay
                    selectedSnap={selectedSnap}
                    snapCount={snapCount}
                />
            </div> */}
        </section>
    )
}

export default Carousel
